/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     伙伴 接口
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const generalApiHost = process.env.VUE_APP_GENERAL_API_HOST;

export function partnerOverviewApi(params) {
  return request({
    url: generalApiHost + '/god/partner/overview',
    method: 'get',
    params
  })
}

export function leadValidateApi(data) {
  return request({
    url: generalApiHost + '/god/lead/validate',
    method: 'post',
    data
  })
}

export function leadCreateApi(data) {
  return request({
    url: generalApiHost + '/god/lead/create',
    method: 'post',
    data
  })
}

export function companyQueryApi(params) {
  return request({
    url: generalApiHost + '/company/query',
    method: 'get',
    params
  })
}

export function companyCheckApi(data) {
  return request({
    url: generalApiHost + '/company/check',
    method: 'post',
    data
  })
}

export function leadListApi(params) {
  return request({
    url: generalApiHost + '/god/customer/lead/list',
    method: 'get',
    params
  })
}

export function companyCreateApi(data) {
  return request({
    url: generalApiHost + '/company/create',
    method: 'post',
    data
  })
}

export function certificateGetApi(params) {
  return request({
    url: generalApiHost + '/god/partner/certificate/get',
    method: 'get',
    params
  })
}

